import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";

export async function getStats(params) {
  return await new API(URL.setParams(URL.buildUrl("stats"), params)).get();
}
export async function updateStats(params) {
  return await new API(URL.buildUrl("stats")).put(params);
}
